const n = (e, t) => {
  var a;
  return (a = e.data[t]) == null ? void 0 : a.bins.map((r) => r.value).join("");
};
export {
  n as miniBarChartCellValueGetter
};
//# sourceMappingURL=index.es638.js.map
